<template>
    <div class="listing-in">
        <div class="listing-contact">
          <span class="listing-contact-name">{{contact.name}} {{contact.surname}}</span><br/>
          <a class="listing-contact-phone" :href="'tel:'+contact.phone">{{contact.phone}}</a>,
          <a class="listing-contact-email" :href="'mailto:'+contact.email">{{contact.email}}</a>
        </div>
        <div class="listing-detail" v-for="regionWithDistricts in contact.regionsWithDistricts">
            <span class="region-name">{{regionWithDistricts.region.name}}:</span>
            <span class="name">
              {{districtList(regionWithDistricts.districts)}}
            </span>
        </div>
    </div>
</template>

<script>
  import map from 'lodash/map';

    export default {
        name: 'ContactContactItem',
        props: {
            contact: {
                required: true
            }
        },
      methods: {
          districtList(districts) {
            return map(districts, (district) => district.name).join(', ');
          }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactItem.vue